<div id="system-usage-viewport">
  <!-- System usage header -->
  <div id="system-usage-header">
    <div class="col-md-12 page-title-box internal-page-title align-middle">
      <span>System Usage Report</span>
    </div>
  </div>

  <div class="system-usage-body">
    <ng-container *ngIf="loading()"><img src="/assets/images/loading.gif" width="20" height="20" /></ng-container>
    <ng-container *ngIf="!loading()">
      <select [(ngModel)]="selectedTimeframe" (ngModelChange)="onTimeframeChange($event)">
        <option *ngFor="let timeframe of timeframes" [ngValue]="timeframe">
          {{ timeframe.name }}
        </option>
      </select>
      <select [(ngModel)]="selectedUsersFilter" (ngModelChange)="onUsersFilterChange($event)">
        <option *ngFor="let usersFilter of usersFilters" [ngValue]="usersFilter">
          {{ usersFilter }}
        </option>
      </select><br />
      <ng-container *ngIf="!hasData">
        <p>No data</p>
      </ng-container>
      <ng-container *ngIf="hasData">
        <div id="system-usage-table-viewport">
          <table>
            <thead>
              <tr>
                <th [attr.rowspan]="4" class="bottom sticky stickiest">User</th>
                <ng-container *ngFor="let iface of tableModel().interfaces">
                  <th [attr.colspan]="iface.colspan">
                    {{ getInterfaceName(iface.interface) }}
                  </th>
                </ng-container>
                <th [attr.rowspan]="3" class="no-right-border">Total</th>
              </tr>
              <tr>
                <ng-container *ngFor="let iface of tableModel().interfaces">
                  <ng-container *ngFor="let module of iface.modules">
                    <th [attr.colspan]="module.colspan">
                      {{ getModuleName(module.module) }}
                    </th>
                  </ng-container>
                </ng-container>
              </tr>
              <tr>
                <ng-container *ngFor="let iface of tableModel().interfaces">
                  <ng-container *ngFor="let module of iface.modules">
                    <ng-container *ngFor="let action of module.actions">
                      <th>
                        {{ getActionName(action.action) }}
                      </th>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </tr>
              <tr>
                <ng-container *ngFor="let iface of tableModel().interfaces">
                  <ng-container *ngFor="let module of iface.modules">
                    <ng-container *ngFor="let action of module.actions">
                      <th class="right">
                        {{ action.total }}
                      </th>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <th class="right no-right-border">{{ tableModel().total }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let row of tableModel().rows">
                <tr>
                  <td class="sticky">{{ row.user }}</td>
                  <ng-container *ngFor="let cell of row.cells">
                    <td class="right">
                      {{ cell.value == null ? '&nbsp;' : cell.value }}
                    </td>
                  </ng-container>
                  <td>{{ row.total }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

